<template>
  <div>
    <page-toolbar v-model="search">
      <template #filters>
        <v-col cols="auto">
          <date-picker v-model="dates" :disabled="loading.getReport" color="white" />
        </v-col>

        <v-col cols="auto">
          <company-report-field-select-companies
            hide-details
            :items="companies"
            :loading="loading.fetchCompanies"
            :disabled="loading.getReport || loading.fetchCompanies"
            color="white"
          />
        </v-col>

        <v-col cols="auto" v-if="tab == 1 && user.type != 'company'">
          <autocomplete
            v-model="pretragaSmena"
            :items="smene"
            :label="$t('shifts')"
            item-text="company"
            item-value="id"
            clear
            chips
            small-chips
            :disabled="loading.getReport"
            color="white"
          />
        </v-col>
      </template>
    </page-toolbar>

    <div class="px-6 mt-2">
      <v-row>
        <v-col cols="12" v-if="loading.getReport || loading.fetchCompanies">
          <v-row justify="center" align="center" style="min-height: 300px">
            <v-col cols="auto">
              <v-progress-circular
                indeterminate
                size="64"
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else-if="$store.state.company?.type === 'group'" cols="12">
          <group-company-reports :date="date"></group-company-reports>
        </v-col>
        <v-col v-else-if="user.type === 'company'" cols="12">
          <company-report-tabs></company-report-tabs>
        </v-col>
      </v-row>
    </div>

    <global-dialog-card
      v-model="errorToManyAttempts"
      hide-actions
      :title="$t('too_many_requests')"
    >
      <p>
        {{ $t("too_many_requests_message") }}
      </p>
    </global-dialog-card>
  </div>
</template>

<script>
import moment from "moment";
import groupCompanyReports from "@/components/company/reports/group.vue";
import companyReportTabs from "@/components/company/reports/company-reports.vue";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";
import hasSnackbar from "@/mixins/hasSnackbar";
import companyService from "@/services/company";
import reportService from "@/services/report";
import CompanyReportFieldSelectCompanies from "@/components/company/reports/fields/CompanyReportFieldSelectCompanies.vue";

export default {
  name: "CompanyDefaultReport",
  mixins: [hasPrinting, hasExcel, hasSnackbar],
  components: {
    groupCompanyReports,
    companyReportTabs,
    CompanyReportFieldSelectCompanies,
  },
  data() {
    return {
      moment: moment,
      pretragaSmena: "",
      smene: [],
      date: [new Date().toISOString().substr(0, 10)],
      report: null,
      dialog: false,
      printTable: "table3",
      meals: null,
      users: [],
      tab: 0,
      companies: [],
      company: [],
      dates: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
      total: [],
      errorToManyAttempts: false,
      loading: {
        fetchCompanies: false,
        getReport: false,
      },
    };
  },
  created() {
    this.fetchCompanies();
  },
  methods: {
    async fetchCompanies() {
      if (this.loading.fetchCompanies) {
        console.warn(
          "Fetch companies operation already in progress, skipping duplicate request"
        );
        return;
      }

      this.loading.fetchCompanies = true;

      try {
        const { data: companies } = await companyService.getBranches({
          companies: this.$store.state.company?.id,
        });
        this.companies = companies.map((company) => {
          return {
            id: company[0],
            name: company[1],
          };
        });
      } catch (error) {
        console.error("Error fetching companies:", error);
        this.showErrorSnackbar(error, this.$t("error_loading_companies"));
      } finally {
        this.loading.fetchCompanies = false;
      }
    },
    async getReport() {
      if (this.loading.getReport) {
        console.warn(
          "Get report operation already in progress, skipping duplicate request"
        );
        return;
      }

      let companies = [];
      (this.$store.state.report.selectedFoodCompanies || []).filter((item) => {
        if (item.id) {
          companies.push(item.id);
        } else {
          companies.push(item);
        }
      });

      this.errorToManyAttempts = false;
      this.loading.getReport = true;

      const startAt = moment(this.date[0]).format("YYYY-MM-DD");
      const endAt = moment(this.date[1]).format("YYYY-MM-DD");

      try {
        const res = await reportService.getCompanyFoodKorisnici(companies, {
          date: startAt,
          date2: endAt,
        });

        let order_count_total = 0;
        let order_payed_total = 0;
        let order_meals_total = 0;

        res.data.users.forEach((user) => {
          order_count_total += user.order_count;
          order_payed_total += user.order_payed;
          order_meals_total += user.meals;
        });
        res.data.users.push({
          id: "УКУПНО:",
          order_count: order_count_total,
          order_payed: order_payed_total,
          meals: order_meals_total,
        });

        this.$root.$emit("getNewCompany", res.data.users);
      } catch (error) {
        console.error("Error loading report:", error);
        if (error.response?.status == 429) {
          this.errorToManyAttempts = true;
        } else {
          this.showErrorSnackbar(error, this.$t("error_loading_report"));
        }
        setTimeout(() => {
          this.errorToManyAttempts = false;
        }, 8000);
      } finally {
        this.loading.getReport = false;
      }
    },
    print(id, type = false) {},
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    search: {
      get() {
        return this.$store.state.report.filters.search;
      },
      set(value) {
        this.$store.commit("report/SET_FILTER", { key: "search", value });
      },
    },
  },
  watch: {
    dates() {
      if (
        new Date(this.dates[1]).getTime() < new Date(this.dates[0]).getTime() ||
        !this.dates[1]
      ) {
        this.dates[1] = this.dates[0];
      } else {
        this.$store.commit("report/SET_DATE_RANGE", {
          from: this.dates[0],
          to: this.dates[1],
        });
      }
      this.date[0] = this.dates[0];
      this.date[1] = this.dates[1];
      this.getReport();
    },
    pretragaSmena() {
      this.$root.$emit("pretragaSmena", this.pretragaSmena);
    },
  },
};
</script>
